import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseListContainer from '../../baseContainers/BaseListContainer';
import ActionLink from '../../components/ActionLink';
import CriteriaDropdownComponent from '../../components/criteria/CriteriaDropdownComponent';
import EmailService from '../../services/EmailService';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import { Button, Menu } from 'primereact';

class EmailListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new EmailService());
        this.state = {
            list: [],
            loading: true,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            filters: {},
            emailTypeOptions: [],
        };
    }

    updateSearchCriteria(criteria) {
        return {
            locale: criteria.locale,
            emailType: criteria.emailType,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {
        return {
            emailType: undefined,
            locale: this.authService.getI18n(),
            firstResult: 0,
            maxResults: 10,
            sortField: 'id',
            sortAsc: true,
        };
    }
    getDataKey() {
        return 'id';
    }
    getListTitle() {
        return '';
    }
    getCriteriaName() {
        return 'email-list-sc';
    }

    initializeFromBackend() {
        this.enumService
            .getLocalizedEnumListForLocale('EmailType')
            .then((emailTypeOptions) => {
                this.setState({
                    emailTypeOptions,
                });
            })
            .catch(() => {
                this.showErrorMessage(t('error.getTypeOfMessagesError'));
            });
    }

    getContainerListName() {
        return 'email-list-container';
    }

    renderCriteria() {
        return (
            <div className='row'>
                <CriteriaDropdownComponent
                    id='emailType-sc'
                    name='emailType'
                    showClear
                    label={t('email.type')}
                    colClass='col-xl-6 col-lg-6 col-md-12 col-sm-12'
                    value={this.state.criteria.emailType}
                    options={this.state.emailTypeOptions}
                    onAfterStateChange={() => console.log(this.state)}
                    placeholder={''}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                />
            </div>
        );
    }

    prepareColumns() {
        return [
            {
                field: 'emailType',
                header: t('global.messageType'),
                sortable: true,
            },
            {
                key: 'actions',
                header: t('global.action'),
                body: this.actionTemplate,
                className: 'table-column-action',
                float: 'center',
            },
        ];
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }


    actionTemplate(rowData) {
        const menuRef = React.createRef();
        const { editUrl } = this.props;
        const editHref = `${editUrl}/${rowData?.id}/` + sessionStorage.getItem('i18nextLng');
    
        const menuItems = [
            {
                label: t('global.details'),
                icon: 'pi pi-eye',
                command: () => this.handleGoToDetail(editHref),
            }
        ];
    
        return (
            <div>
                <Menu model={menuItems} popup ref={menuRef} />
                <Button
                    icon="pi pi-ellipsis-v"
                    className="menu-items"
                    onClick={(event) => menuRef.current.toggle(event)}
                />
            </div>
        );
    }

    breadCrumbItems() {
        return [{name: t('email.templates'), url: '/email-template-list'}];
    }
    render() {
        return <div className='container-fluid'>{this.renderView()}</div>;
    }
}

EmailListContainer.defaultProps = {
    detailUrl: '/email-template/details',
    newUrl: '/email-template/create',
    editUrl: '/email-template/edit',
    lazy: true,
};

EmailListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
};

export default withRouter(withTranslation()(EmailListContainer));
